import { type DocumentReference } from 'firebase/firestore';

import { DocumentCollectionType } from 'types/DocumentCollectionType';
import { DocumentType } from 'types/DocumentType';
import { type LogEntry } from 'types/LogEntry';
import { nullTimestamp } from 'utils/FirestoreUtils';

import DocumentCollection from './DocumentCollection';
import { DocumentSchema } from './DocumentSchema';
import DocumentStore from './DocumentStore';
import {
    VideoBundleElement,
    type VideoBundleElementSchema,
} from './VideoBundleElement';
import type VideoBundlesManager from './VideoBundlesManager';

export class VideoBundleSchema extends DocumentSchema {
    archivePath = '';
    createTime = nullTimestamp();
    errors: string[] = [];
    initiatingUser = '';
    log: LogEntry[] = [];
    modifiedTime = nullTimestamp();
    name = '';
    pendingCount = 0;
    stagePrefix = '';
    status: 'notset' | 'pending' | 'new' | 'changing' | 'complete' | 'error' =
        'notset';
}

export default class VideoBundle extends DocumentStore<VideoBundleSchema> {
    declare parent: VideoBundlesManager | undefined;

    type = DocumentType.VIDEO_BUNDLE;
    collectionType = DocumentCollectionType.VIDEO_BUNDLE;
    schema = new VideoBundleSchema();
    elements = new DocumentCollection<
        VideoBundleElement,
        VideoBundleElementSchema
    >(this, VideoBundleElement);

    constructor(parent: VideoBundlesManager, docRef?: DocumentReference) {
        super(parent, docRef);
        this.becomeObservable();
        this.elements.becomeObservable();
    }

    get progress() {
        return this.status === 'complete' ? 100 : 0;
    }

    onLoad = async (_data: VideoBundleSchema) => {
        if (!this.elements.mounted) {
            await this.elements.load();
        }
    };

    onReady = async () => {
        if (!this.elements.mounted) {
            await this.elements.load();
        }
    };
}
